const isServerSide = () => !(typeof window !== 'undefined' && window.document && window.document.createElement)

export default isServerSide
